import { Module } from '@nu-art/ts-common';
import { ThunderDispatcher } from '../core/thunder-dispatcher.js';
class ModuleFE_ConnectivityModule_Class extends Module {
    connected;
    dispatch_onConnectivityChange = new ThunderDispatcher('__onConnectivityChange');
    constructor() {
        super();
        this.connected = this.getConnectivityStatus();
    }
    init() {
        window.addEventListener('online', this.handleConnectionChange);
        window.addEventListener('offline', this.handleConnectionChange);
        // ModuleFE_FirebaseListener.createListener('.info').startListening(snapshot => {
        // 	if (snapshot.val() === true) {
        // 		this.logWarningBold(`Connected to Firebase ${__stringify(snapshot.val())}`);
        // 		// Perform actions when connected
        // 	} else {
        // 		this.logWarningBold(`Disconnected from Firebase ${__stringify(snapshot.val())}`);
        // 		// Handle disconnection
        // 	}
        // });
    }
    isConnected = () => this.connected;
    handleConnectionChange = () => {
        this.connected = this.getConnectivityStatus();
        this.dispatch_onConnectivityChange.dispatchModule();
        this.dispatch_onConnectivityChange.dispatchUI();
    };
    getConnectivityStatus = () => navigator.onLine;
}
export const ModuleFE_ConnectivityModule = new ModuleFE_ConnectivityModule_Class();
//# sourceMappingURL=ModuleFE_ConnectivityModule.js.map